import { useEffect } from "react";
import { logoutRequest } from "../redux/modules/auth/authSlice";
import { getMyRequest, getRolesRequest } from "../redux/modules/permissions/slice";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { Stack } from "@mui/material";
import AdminLayout from "./adminLayout";
import Header from "../component/header";
import Footer from "../component/footer";
import PatientLayout from "./patientLayout";
import ExternalReferrerLayout from "./externalReferrerLayout";


export default function Layout({ layoutName, proctedRoute = false }) {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn, userData } = useSelector((state) => state.auth);
    const { roles } = useSelector((state) => state.permissions);

    // Load the user's capabilities on login/refresh and keep them fresh on every
    // navigation, so an admin's change to a role reaches an already-logged-in
    // user on their next page change (no re-login needed).
    useEffect(() => {
        if (isLoggedIn && userData?.role) {
            dispatch(getMyRequest({ role: userData.role }));
            if (!roles || roles.length === 0) {
                dispatch(getRolesRequest());
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, userData?.role, location.pathname]);

    useEffect(() => {
        if (proctedRoute) {
            if (isLoggedIn) {
                const currentTime = new Date().getTime() / 1000;
                const timeUntilExpiration = Math.floor(userData.exp - currentTime);
                if (timeUntilExpiration <= 0) {
                    dispatch(logoutRequest());
                } else {
                    let tokenExpiryTimer = setTimeout(() => {
                        toast("Session time expired please login again");
                        dispatch(logoutRequest());
                    }, timeUntilExpiration * 1000);
                    return () => {
                        clearTimeout(tokenExpiryTimer);
                    };
                }
            } else {
                navigate("/login");
            }
        }
    }, [dispatch, navigate, proctedRoute, isLoggedIn, userData]);

    if (proctedRoute && !isLoggedIn) {
        return <Navigate to="login" />
    }

    if (layoutName === "admin") {
        // if (layoutName !== userData.role) { return <Navigate to={userData.role} /> }
        return (<AdminLayout><Outlet /></AdminLayout>)
    }

    if (layoutName === "patient") {
        return (<PatientLayout><Outlet /></PatientLayout>)
    }

    if (layoutName === "externalReferrer") {
        return (<ExternalReferrerLayout><Outlet /></ExternalReferrerLayout>)
    }

    if (layoutName === "auth") {
        return (
            <>
                <Stack sx={{ height: "100vh" }} justifyContent="center">
                    <Outlet />
                </Stack>
            </>
        )
    }
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}